<app-header></app-header>
<ion-content scroll-y="true">
  <!-- START DESKTOP -->
  <div
    id="desktop"
    *ngIf="platformService?.platformType === platformService?.platformEnum?.desktop"
  >
    <div *ngIf="true === (dynamicOrderInsightsTabsFeatureFlag$ | async)">
      <app-order-insights-page-header
        [isLoading]="false"
        [quickFilters]="quickFilters"
        [breadcrumbs]="breadcrumbs"
        [order]="order"
        [percentagesDisplayed]="percentagesDisplayed"
        [downloadModalIsOpen$]="downloadModalIsOpen$"
        (downloadModalStateChange)="showDownloadInsightsModal($event)"
      >
      </app-order-insights-page-header>
      <ion-grid [fixed]="true">
        <!-- Products display section -->
        <div
          class="product-group-section"
          *ngFor="let tab of quickFilters; last as lastItem; index as i;"
        >
          <ng-container *ngIf="tab?.selected">
            <ng-container
              *ngFor="let insightProductGroup of tab?.insightsProducts"
            >
              <!-- If "All" tab is selectedand there are products in the insight product group,
                  only show tab discription above products if there are products in the group -->
              <div
                *ngIf="tab?.title === 'All' && insightProductGroup?.products?.length > 0; else noTitleRow"
              >
                <ion-row>
                  <div class="product-tabs-header-section">
                    <div>
                      {{ insightProductGroup?.title }}
                      <span>
                        <ion-badge [ngClass]="insightProductGroup?.badgeColor"
                          >{{ insightProductGroup?.products?.length
                          }}</ion-badge
                        >
                      </span>
                    </div>
                  </div>
                </ion-row>
              </div>
              <!-- Adds padding to the top of the products listed if a non "All" tab is selected,
                  since there should be no title row above the products -->
              <ng-template #noTitleRow>
                <div class="header-section" *ngIf="tab?.title !== 'All'">
                  <div
                    *ngIf="insightProductGroup?.products?.length === 0"
                    data-cy="no-orders-container"
                    class="no-orders-container"
                  >
                    <img
                      src="assets/images/box-dimension-black.svg"
                      class="box-dimension-image"
                      alt="box-image"
                    />
                    <p data-cy="no-open-orders-message">No Products Found</p>
                  </div>
                </div>
              </ng-template>
              <!-- Display products in insight product group -->
              <div
                *ngFor="let product of insightProductGroup?.products; last as lastItem; index as i"
              >
                <app-order-insights-product-desktop
                  [product]="product"
                  [lastOrderedDate]="lastOrderedDates[product?.productNumber]"
                  [isDyfNotOrderedProduct]="order?.orderHeader?.dyfProductsNotOrdered?.includes(product?.productNumber)"
                  [newProductOrdered]="order?.orderHeader?.newProductsOrderedNotInRecentlyPurchased?.includes(product?.productNumber)"
                  [order]="order"
                  [orderItems]="(cartOrderVm$ | async)?.orderItemState"
                  [isOnline]="(panAppState.online$ | async)"
                  (quantityUpdateEmitter)="changeQuantityHandler($event)"
                  (handleClick)="routeToProductDetails(product?.productNumber)"
                ></app-order-insights-product-desktop>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </ion-grid>
    </div>
    <!-- else show the old insights page -->
    <ion-grid
      [fixed]="true"
      *ngIf="false === (dynamicOrderInsightsTabsFeatureFlag$ | async)"
    >
      <ion-row>
        <ion-col>
          <div class="header-section">
            <div class="breadcrumbs-section">
              <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
            </div>
            <div class="title-and-download">
              <h1 data-cy="my-orders-view-title-text">
                {{ 'i18n.orderInsightsPage.orderInsight' | translate }}
              </h1>
              <div>
                <ion-button
                  class="btn-download"
                  fill="clear"
                  (click)="showDownloadInsightsModal(true)"
                  ><ion-icon name="download-outline"></ion-icon>{{
                  'i18n.orderInsightsPage.download' | translate }}
                </ion-button>
              </div>
            </div>
            <div class="cookbook-and-delivery-date-row">
              <div class="delivery-date">
                <div class="delivery-date-and-order-number">
                  <div>
                    <span
                      >{{ 'i18n.orderInsightsPage.orderNum' | translate }}</span
                    >
                    <span
                      >&nbsp;{{ order?.orderHeader?.tandemOrderNumber }}</span
                    >
                  </div>
                  <div>
                    <span
                      >{{ 'i18n.orderInsightsPage.delivery' | translate }}</span
                    >
                    <span>
                      &nbsp;{{ order?.orderHeader?.confirmedDeliveryDate | date:
                      'fullDate':'GMT' }}
                    </span>
                  </div>
                </div>
              </div>
              <app-order-percentages-bar
                [data]="percentagesDisplayed"
              ></app-order-percentages-bar>
            </div>
          </div>
        </ion-col>
      </ion-row>
      <ng-container
        *ngIf="(order?.orderHeader?.dyfProductsNotOrdered?.length || order?.orderHeader?.newProductsOrderedNotInRecentlyPurchased?.length); else noInsights"
      >
        <div *ngIf="order?.orderHeader?.dyfProductsNotOrdered.length">
          <ion-row>
            <ion-col>
              <div class="header-section">
                <div>
                  {{ 'i18n.orderInsightsPage.lostLines' | translate }}
                  <span>
                    <ion-badge class="red-badge"
                      >{{ order?.orderHeader?.dyfProductsNotOrdered.length
                      }}</ion-badge
                    >
                  </span>
                </div>
              </div>
            </ion-col>
          </ion-row>

          <div
            *ngFor="let productNumber of order?.orderHeader?.dyfProductsNotOrdered; last as lastItem; index as i;"
          >
            <app-order-insights-product-desktop
              [product]="productMap.get(productNumber)"
              [lastOrderedDate]="lastOrderedDates[productNumber]"
              [isDyfNotOrderedProduct]="true"
              [order]="order"
              [orderItems]="(cartOrderVm$ | async)?.orderItemState"
              [isOnline]="(panAppState.online$ | async)"
              (quantityUpdateEmitter)="changeQuantityHandler($event)"
              (handleClick)="routeToProductDetails(productNumber)"
            ></app-order-insights-product-desktop>
          </div>
        </div>
      </ng-container>
      <div
        *ngIf="order?.orderHeader?.newProductsOrderedNotInRecentlyPurchased?.length"
      >
        <ion-row>
          <ion-col>
            <div class="header-section">
              <div>
                {{ 'i18n.orderInsightsPage.newOrder' | translate }}
                <span>
                  <ion-badge class="green-badge"
                    >{{order?.orderHeader?.newProductsOrderedNotInRecentlyPurchased.length}}</ion-badge
                  >
                </span>
              </div>
            </div>
          </ion-col>
        </ion-row>

        <div
          *ngFor="let productNumber of order?.orderHeader?.newProductsOrderedNotInRecentlyPurchased; last as lastItem; index as i;"
        >
          <app-order-insights-product-desktop
            [product]="productMap.get(productNumber)"
            [lastOrderedQuantity]="getOrderedQuantityString(productNumber)"
            [isOnline]="(panAppState.online$ | async)"
            [newProductOrdered]="true"
            (handleClick)="routeToProductDetails(productNumber)"
          ></app-order-insights-product-desktop>
        </div>
      </div>
    </ion-grid>
  </div>
  <!-- END DESKTOP -->

  <!-- START TABLET -->
  <div
    id="tablet"
    *ngIf="platformService?.platformType === platformService?.platformEnum?.tablet"
  >
    <div *ngIf="true === (dynamicOrderInsightsTabsFeatureFlag$ | async)">
      <app-order-insights-page-header
        [isLoading]="false"
        [quickFilters]="quickFilters"
        [breadcrumbs]="breadcrumbs"
        [order]="order"
        [percentagesDisplayed]="percentagesDisplayed"
        [downloadModalIsOpen$]="downloadModalIsOpen$"
        (downloadModalStateChange)="showDownloadInsightsModal($event)"
      ></app-order-insights-page-header>
      <ion-grid [fixed]="true">
        <!-- Tablet products display section -->
        <div
          class="product-group-section"
          *ngFor="let tab of quickFilters; last as lastItem; index as i;"
        >
          <ng-container *ngIf="tab?.selected">
            <ng-container
              *ngFor="let insightProductGroup of tab?.insightsProducts"
            >
              <!-- If "All" tab is selectedand there are products in the insight product group,
                  only show tab discription above products if there are products in the group -->
              <div
                *ngIf="tab?.title === 'All' && insightProductGroup?.products?.length > 0; else noTitleRow"
              >
                <ion-row>
                  <div class="product-tabs-header-section">
                    <div>
                      {{ insightProductGroup?.title }}
                      <span>
                        <ion-badge [ngClass]="insightProductGroup?.badgeColor"
                          >{{ insightProductGroup?.products?.length
                          }}</ion-badge
                        >
                      </span>
                    </div>
                  </div>
                </ion-row>
              </div>
              <!-- Adds padding to the top of the products listed if a non "All" tab is selected,
                  since there should be no title row above the products -->
              <ng-template #noTitleRow>
                <div class="header-section" *ngIf="tab?.title !== 'All'">
                  <div
                    *ngIf="insightProductGroup?.products?.length === 0"
                    data-cy="no-orders-container"
                    class="no-orders-container"
                  >
                    <img
                      src="assets/images/box-dimension-black.svg"
                      class="box-dimension-image"
                      alt="box-image"
                    />
                    <p data-cy="no-open-orders-message">No Products Found</p>
                  </div>
                </div>
              </ng-template>
              <!-- Display products in insight product group -->
              <div
                *ngFor="let product of insightProductGroup?.products; last as lastItem; index as i"
              >
                <app-order-insights-product-tablet
                  [product]="product"
                  [lastOrderedDate]="lastOrderedDates[product?.productNumber]"
                  [isDyfNotOrderedProduct]="order?.orderHeader?.dyfProductsNotOrdered?.includes(product?.productNumber)"
                  [newProductOrdered]="order?.orderHeader?.newProductsOrderedNotInRecentlyPurchased?.includes(product?.productNumber)"
                  [order]="order"
                  [orderItems]="(cartOrderVm$ | async)?.orderItemState"
                  [isOnline]="(panAppState.online$ | async)"
                  (quantityUpdateEmitter)="changeQuantityHandler($event)"
                  (handleClick)="routeToProductDetails(product?.productNumber)"
                ></app-order-insights-product-tablet>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </ion-grid>
    </div>
    <!-- else show the old insights page -->
    <ion-grid
      [fixed]="true"
      *ngIf="false === (dynamicOrderInsightsTabsFeatureFlag$ | async)"
    >
      <ion-row>
        <ion-col>
          <div class="title-and-download">
            <ion-button
              class="btn-download"
              fill="clear"
              (click)="showDownloadInsightsModal(true)"
              ><ion-icon name="download-outline"></ion-icon>{{
              'i18n.orderInsightsPage.download' | translate }}
            </ion-button>
          </div>
          <div class="cookbook-and-delivery-date-row">
            <div class="delivery-date">
              <div class="delivery-date-and-order-number">
                <div>
                  <span
                    >{{ 'i18n.orderInsightsPage.orderNum' | translate }}</span
                  >
                  <span>&nbsp;{{ order?.orderHeader?.tandemOrderNumber }}</span>
                </div>
                <div>
                  <span
                    >{{ 'i18n.orderInsightsPage.delivery' | translate }}</span
                  >
                  <span>
                    &nbsp;{{ order?.orderHeader?.confirmedDeliveryDate | date:
                    'fullDate':'GMT' }}
                  </span>
                </div>
              </div>
            </div>
            <app-order-percentages-bar
              [data]="percentagesDisplayed"
            ></app-order-percentages-bar>
          </div>
        </ion-col>
      </ion-row>
      <!-- TABLET: NOT ORDERED FROM DYF -->
      <ng-container
        *ngIf="(order?.orderHeader?.dyfProductsNotOrdered?.length || order?.orderHeader?.newProductsOrderedNotInRecentlyPurchased?.length); else noInsights"
      >
        <div *ngIf="order?.orderHeader?.dyfProductsNotOrdered?.length">
          <ion-row>
            <ion-col>
              <div class="header-section">
                <div>
                  {{ 'i18n.orderInsightsPage.lostLines' | translate }}
                  <span>
                    <ion-badge class="red-badge"
                      >{{ order?.orderHeader?.dyfProductsNotOrdered.length
                      }}</ion-badge
                    >
                  </span>
                </div>
              </div>
            </ion-col>
          </ion-row>

          <div
            *ngFor="let productNumber of order?.orderHeader?.dyfProductsNotOrdered; last as lastItem; index as i;"
          >
            <app-order-insights-product-tablet
              [product]="productMap.get(productNumber)"
              [lastOrderedDate]="lastOrderedDates[productNumber]"
              [isDyfNotOrderedProduct]="true"
              [order]="order"
              [orderItems]="(cartOrderVm$ | async)?.orderItemState"
              [isOnline]="(panAppState.online$ | async)"
              (quantityUpdateEmitter)="changeQuantityHandler($event)"
              (handleClick)="routeToProductDetails(productNumber)"
            >
            </app-order-insights-product-tablet>
          </div>
        </div>
      </ng-container>
      <!-- TABLET: NEW PRODUCTS ORDERED -->
      <div
        *ngIf="order?.orderHeader?.newProductsOrderedNotInRecentlyPurchased?.length"
      >
        <ion-row>
          <ion-col>
            <div class="header-section">
              <div>
                {{ 'i18n.orderInsightsPage.newOrder' | translate }}
                <span>
                  <ion-badge class="green-badge"
                    >{{order?.orderHeader?.newProductsOrderedNotInRecentlyPurchased.length}}</ion-badge
                  >
                </span>
              </div>
            </div>
          </ion-col>
        </ion-row>
        <div
          *ngFor="let productNumber of order?.orderHeader?.newProductsOrderedNotInRecentlyPurchased; last as lastItem; index as i;"
        >
          <app-order-insights-product-tablet
            [product]="productMap.get(productNumber)"
            [lastOrderedQuantity]="getOrderedQuantityString(productNumber)"
            [isOnline]="(panAppState.online$ | async)"
            [newProductOrdered]="true"
            (handleClick)="routeToProductDetails(productNumber)"
          ></app-order-insights-product-tablet>
        </div>
      </div>
    </ion-grid>
  </div>
  <!-- END TABLET -->
  <!-- START MOBILE -->
  <div
    id="mobile"
    *ngIf="platformService?.platformType === platformService?.platformEnum?.mobile"
  >
    <div *ngIf="true === (dynamicOrderInsightsTabsFeatureFlag$ | async)">
      <app-order-insights-page-header
        [isLoading]="false"
        [quickFilters]="quickFilters"
        [breadcrumbs]="breadcrumbs"
        [order]="order"
        [percentagesDisplayed]="percentagesDisplayed"
        [downloadModalIsOpen$]="downloadModalIsOpen$"
        (downloadModalStateChange)="showDownloadInsightsModal($event)"
        (additionalOptionsClicked)="openAdditionalOptions($event)"
      >
      </app-order-insights-page-header>
      <ion-grid [fixed]="true">
        <!-- Tablet products display section -->
        <div
          class="product-group-section"
          *ngFor="let tab of quickFilters; last as lastItem; index as i;"
        >
          <ng-container *ngIf="tab?.selected">
            <ng-container
              *ngFor="let insightProductGroup of tab?.insightsProducts"
            >
              <!-- If "All" tab is selectedand there are products in the insight product group,
                  only show tab discription above products if there are products in the group -->
              <div
                *ngIf="tab?.title === 'All' && insightProductGroup?.products?.length > 0; else noTitleRow"
              >
                <ion-row>
                  <div class="product-tabs-header-section">
                    <div>
                      {{ insightProductGroup?.title }}
                      <span>
                        <ion-badge [ngClass]="insightProductGroup?.badgeColor"
                          >{{ insightProductGroup?.products?.length
                          }}</ion-badge
                        >
                      </span>
                    </div>
                  </div>
                </ion-row>
              </div>
              <!-- Adds padding to the top of the products listed if a non "All" tab is selected,
                  since there should be no title row above the products -->
              <ng-template #noTitleRow>
                <div class="header-section" *ngIf="tab?.title !== 'All'">
                  <div
                    *ngIf="insightProductGroup?.products?.length === 0"
                    data-cy="no-orders-container"
                    class="no-orders-container"
                  >
                    <img
                      src="assets/images/box-dimension-black.svg"
                      class="box-dimension-image"
                      alt="box-image"
                    />
                    <p data-cy="no-open-orders-message">No Products Found</p>
                  </div>
                </div>
              </ng-template>
              <!-- Display products in insight product group -->
              <div
                *ngFor="let product of insightProductGroup?.products; last as lastItem; index as i"
              >
                <app-order-insights-product-mobile
                  [product]="product"
                  [lastOrderedDate]="lastOrderedDates[product?.productNumber]"
                  [isDyfNotOrderedProduct]="order?.orderHeader?.dyfProductsNotOrdered?.includes(product?.productNumber)"
                  [newProductOrdered]="order?.orderHeader?.newProductsOrderedNotInRecentlyPurchased?.includes(product?.productNumber)"
                  [order]="order"
                  [orderItems]="(cartOrderVm$ | async)?.orderItemState"
                  [isOnline]="(panAppState.online$ | async)"
                  (quantityUpdateEmitter)="changeQuantityHandler($event)"
                  (handleClick)="routeToProductDetails(product?.productNumber)"
                ></app-order-insights-product-mobile>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </ion-grid>
    </div>
    <!-- else show the old insights page -->
    <ion-grid
      [fixed]="true"
      *ngIf="false === (dynamicOrderInsightsTabsFeatureFlag$ | async)"
    >
      <ion-row>
        <ion-col>
          <div class="mobile-header-and-ellipses">
            <div class="header-section">
              <!-- <div class="order-num-and-date"> -->
              <div>
                <span>{{ 'i18n.orderInsightsPage.orderNum' | translate }}</span>
                <span>&nbsp;{{ order?.orderHeader?.tandemOrderNumber }}</span>
              </div>

              <div class="delivery-date">
                <span>{{ 'i18n.orderInsightsPage.delivery' | translate }}</span>
                <span>
                  &nbsp; {{ order?.orderHeader?.confirmedDeliveryDate | date:
                  'M/d/yyyy':'GMT' }}
                </span>
              </div>
            </div>
            <!-- </div> -->
            <div>
              <ion-icon
                class="additional-info-ellipsis"
                data-cy="additional-info-ellipsis-icon"
                name="ellipsis-vertical-circle-sharp"
                (click)="openAdditionalOptions($event)"
              ></ion-icon>
            </div>
          </div>
          <app-order-percentages-bar
            [data]="percentagesDisplayed"
          ></app-order-percentages-bar>
        </ion-col>
      </ion-row>
      <!-- MOBILE: NOT ORDERED FROM DYF -->
      <ng-container
        *ngIf="(order?.orderHeader?.dyfProductsNotOrdered?.length || order?.orderHeader?.newProductsOrderedNotInRecentlyPurchased?.length); else noInsights"
      >
        <div *ngIf="order?.orderHeader?.dyfProductsNotOrdered?.length">
          <ion-row>
            <ion-col>
              <div class="header-section">
                <div>
                  {{ 'i18n.orderInsightsPage.lostLines' | translate }}
                  <span>
                    <ion-badge class="red-badge"
                      >{{ order?.orderHeader?.dyfProductsNotOrdered?.length
                      }}</ion-badge
                    >
                  </span>
                </div>
              </div>
            </ion-col>
          </ion-row>

          <div
            *ngFor="let productNumber of order?.orderHeader?.dyfProductsNotOrdered; last as lastItem; index as i;"
          >
            <app-order-insights-product-mobile
              [product]="productMap.get(productNumber)"
              [lastOrderedDate]="lastOrderedDates[productNumber]"
              [isDyfNotOrderedProduct]="true"
              [order]="order"
              [orderItems]="(cartOrderVm$ | async)?.orderItemState"
              [isOnline]="(panAppState.online$ | async)"
              (quantityUpdateEmitter)="changeQuantityHandler($event)"
              (handleClick)="routeToProductDetails(productNumber)"
            ></app-order-insights-product-mobile>
          </div>
        </div>
      </ng-container>
      <!-- MOBILE: NEW PRODUCTS ORDERED -->
      <div
        *ngIf="order?.orderHeader?.newProductsOrderedNotInRecentlyPurchased?.length"
      >
        <ion-row>
          <ion-col>
            <div class="header-section">
              <div>
                {{ 'i18n.orderInsightsPage.newOrder' | translate }}
                <span>
                  <ion-badge class="green-badge"
                    >{{order?.orderHeader?.newProductsOrderedNotInRecentlyPurchased.length}}</ion-badge
                  >
                </span>
              </div>
            </div>
          </ion-col>
        </ion-row>

        <div
          *ngFor="let productNumber of order?.orderHeader?.newProductsOrderedNotInRecentlyPurchased; last as lastItem; index as i;"
        >
          <app-order-insights-product-mobile
            [product]="productMap.get(productNumber)"
            [lastOrderedQuantity]="getOrderedQuantityString(productNumber)"
            [isOnline]="(panAppState.online$ | async)"
            [newProductOrdered]="true"
            (handleClick)="routeToProductDetails(productNumber)"
          ></app-order-insights-product-mobile>
        </div>
      </div>
    </ion-grid>
  </div>
  <!-- END MOBILE -->
  <app-footer></app-footer>
</ion-content>
<ion-modal
  [ngClass]="(platformService?.isTouchExperience$ | async) ? 'ion-modal-touch' : 'modal-desktop-size-lg'"
  [initialBreakpoint]="platformService.platformType !== platformService.platformEnum.desktop ? 1 : undefined"
  [breakpoints]="platformService.platformType !== platformService.platformEnum.desktop  ? [0, 0.5, 1] : undefined"
  [isOpen]="downloadModalIsOpen$ | async"
  (ionModalDidDismiss)="showDownloadInsightsModal(false)"
>
  <ng-template>
    <app-simple-download-orders-modal
      class="ion-page"
      [orders]="[order]"
      [fileTypes]="downloadFileTypes"
      [platform]="platformService.platformType"
      (dismissEvent)="showDownloadInsightsModal(false)"
      (downloadOrdersEmitter)="handleDownloadInsights($event)"
      fileName="{{order?.orderHeader?.customerNumber}}_Order_Insights_{{order?.orderHeader?.tandemOrderNumber}}"
      [showOrdersDropdown]="false"
    >
    </app-simple-download-orders-modal>
  </ng-template>
</ion-modal>

<ng-template #noInsights>
  <ion-row>
    <ion-col>
      <div
        class="header-section"
        *ngIf="!!order && order?.orderHeader?.cookbookAdoptionPercent >= 0"
      >
        <div>{{'i18n.orderInsightsPage.noInsightsToDisplay'| translate}}</div>
      </div>
    </ion-col>
  </ion-row></ng-template
>
